export const Life = {
	target1: {
		toAgeWholeLife: {
			companyName: 'Momentum',
			minAges: { any: 15 },
			maxAges: { any: 80 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: '20xAnSal' }, students: { any: 500000 } }
		}
	},
	target3: {
		toAgeWholeLife: {
			companyName: 'Sanlam',
			minAges: {
				level: 15,
				fivePercent: 30,
				ageRated: 15
			},
			maxAges: { any: 79 },
			minCovers: { defaults: { any: 150000 } },
			maxCovers: {
				defaults: { any: 100000000 },
				students: {
					'15-18': 1000000,
					'19+': 2000000
				}
			}
		}
	},
	target10: {
		toAgeWholeLife: {
			companyName: 'Bidvest',
			minAges: { any: 18 },
			maxAges: { any: 75 },
			minCovers: { defaults: { any: 150000 } },
			maxCovers: {
				defaults: { any: '20xAnSal' },
				absoluteMax: { any: 50000000 }
			}
		}
	},
	target2: {
		toAgeWholeLife: {
			companyName: 'Liberty',
			minAges: {
				level: 15,
				fivePercent: 25,
				ageRated: 20
			},
			maxAges: { any: 80 },
			minCovers: {
				defaults: { any: 150000 }
			},
			maxCovers: {
				defaults: { any: 100000000 },
				students: {
					any: 1500000
				}
			}
		}
	}
};

export const ComprehensiveDisability = {
	target1: {
		toAgeAny: {
			minAges: { any: 15 },
			maxAges: { any: 70 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 25000000 } }
		}
	},
	target3: {
		toAge65: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 50000 } },
			maxCovers: {
				defaults: { any: 30000000 },
				absoluteMax: { any: '20xAnSal' }
			}
		},
		toAge70: {
			minAges: { any: 'na' },
			maxAges: { any: 'na' },
			minCovers: { defaults: { any: 'na' } },
			maxCovers: { defaults: { any: 'na' } }
		}
	},
	target10: {
		toAgeAny: {
			minAges: { any: 18 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 20000000 } }
		}
	},
	target2: {
		toAgeAny: {
			minAges: { level: 15, fivePercent: 25, ageRated: 20 },
			maxAges: {
				level: 'yearsBeforeBenefitCeaseAge:10',
				fivePercent: 'yearsBeforeBenefitCeaseAge:10',
				ageRated: 'yearsBeforeBenefitCeaseAge:10'
			},
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 60000000 } }
		}
	}
};

export const OwnOccupationDis = {
	target1: {
		toAgeAny: {
			minAges: { any: 15 },
			maxAges: { any: 70 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 25000000 } }
		}
	},
	target3: {
		toAge65: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 50000 } },
			maxCovers: {
				defaults: { any: 30000000 },
				absoluteMax: { any: '20xAnSal' }
			}
		},
		toAge70: {
			minAges: { any: 'na' },
			maxAges: { any: 'na' },
			minCovers: { defaults: { any: 'na' } },
			maxCovers: { defaults: { any: 'na' } }
		}
	},
	target10: {
		toAgeAny: {
			minAges: { any: 18 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 20000000 } }
		}
	},
	target2: {
		toAgeAny: {
			minAges: { level: 15, fivePercent: 25, ageRated: 20 },
			maxAges: {
				level: 'yearsBeforeBenefitCeaseAge:10',
				fivePercent: 'yearsBeforeBenefitCeaseAge:10',
				ageRated: 'yearsBeforeBenefitCeaseAge:10'
			},
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 60000000 } }
		}
	}
};

export const Impairment = {
	target1: {
		toAgeAny: {
			minAges: { any: 15 },
			maxAges: { any: 70 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 25000000 } }
		}
	},
	target3: {
		toAge65: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 50000 } },
			maxCovers: {
				defaults: { any: 30000000 },
				absoluteMax: { any: '20xAnSal' }
			}
		},
		toAge70: {
			minAges: { any: 'na' },
			maxAges: { any: 'na' },
			minCovers: { defaults: { any: 'na' } },
			maxCovers: { defaults: { any: 'na' } }
		}
	},
	target10: {
		toAgeAny: {
			minAges: { any: 18 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 20000000 } }
		}
	},
	target2: {
		toAgeAny: {
			minAges: { level: 15, fivePercent: 25, ageRated: 20 },
			maxAges: {
				level: 'yearsBeforeBenefitCeaseAge:10',
				fivePercent: 'yearsBeforeBenefitCeaseAge:10',
				ageRated: 'yearsBeforeBenefitCeaseAge:10'
			},
			minCovers: { defaults: { any: 100000 } },
			maxCovers: { defaults: { any: 60000000 } }
		}
	}
};

export const CritIllness = {
	target1: {
		toAge65: {
			minAges: { any: 15 },
			maxAges: { any: 65 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 4500000 },
				students: { any: 1000000 },
				professional: { any: 5000000 }
			}
		},
		toAgeWholeLife: {
			minAges: { any: 15 },
			maxAges: { any: 70 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 5000000 },
				students: { any: 1000000 },
				professional: { any: 5500000 }
			}
		}
	},
	target3: {
		toAge65: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 50000 } },
			maxCovers: {
				defaults: { any: 6000000 },
				absoluteMax: { any: '20xAnSal' }
			}
		},
		toAgeWholeLife: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 65 },
			minCovers: { defaults: { any: 50000 } },
			maxCovers: {
				defaults: { any: 6000000 },
				absoluteMax: { any: '20xAnSal' }
			}
		}
	},
	target10: {
		toAge65: {
			minAges: { any: 18 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 5000000 }
			}
		},
		toAgeWholeLife: {
			minAges: { any: 18 },
			maxAges: { any: 70 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 5000000 }
			}
		}
	},
	target2: {
		toAge65: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 60 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 6000000 }
			}
		},
		toAgeWholeLife: {
			minAges: { level: 15, fivePercent: 30, ageRated: 15 },
			maxAges: { any: 65 },
			minCovers: { defaults: { any: 100000 } },
			maxCovers: {
				defaults: { any: 6000000 }
			}
		}
	}
};

export const TemporaryIncomeProtector = {
	target1: {
		minAges: { any: 15 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:10'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 }, professional: { any: 200000 } }
	},
	target3: {
		minAges: { level: 17, fivePercent: 30, ageRated: 17 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 3000 } },
		maxCovers: { defaults: { any: 'na' } }
	},
	target10: {
		minAges: { any: 18 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:10'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 } }
	},
	target2: {
		toAge60: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 50, fivePercent: 45, ageRated: 45 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: { defaults: { any: 100000 }, professional: { any: 150000 } }
		},
		toAge65: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 55, fivePercent: 50, ageRated: 50 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: { defaults: { any: 100000 }, professional: { any: 150000 } }
		},
		toAge70: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 65, fivePercent: 60, ageRated: 60 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: { defaults: { any: 100000 }, professional: { any: 150000 } }
		}
	}
};

export const ExtendedIncomeProtector = {
	target1: {
		minAges: { any: 15 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 }, professional: { any: 200000 } }
	},
	target3: {
		minAges: { level: 17, fivePercent: 30, ageRated: 17 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 3000 } },
		maxCovers: { defaults: { any: 'na' } }
	},
	target10: {
		minAges: { any: 18 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 } }
	},
	target2: {
		toAge60: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 50, fivePercent: 45, ageRated: 45 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		},
		toAge65: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 55, fivePercent: 50, ageRated: 50 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		},
		toAge70: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 65, fivePercent: 60, ageRated: 60 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		}
	}
};

export const DIncomeProtector = {
	target1: {
		minAges: { any: 15 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 }, professional: { any: 200000 } }
	},
	target3: {
		minAges: { level: 17, fivePercent: 30, ageRated: 17 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 3000 } },
		maxCovers: { defaults: { any: 'na' } }
	},
	target10: {
		minAges: { any: 18 },
		maxAges: {
			level: 'yearsBeforeBenefitCeaseAge:5',
			fivePercent: 'yearsBeforeBenefitCeaseAge:5',
			ageRated: 'yearsBeforeBenefitCeaseAge:5'
		},
		minCovers: { defaults: { any: 2000 } },
		maxCovers: { defaults: { any: 150000 } }
	},
	target2: {
		toAge60: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 50, fivePercent: 45, ageRated: 45 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		},
		toAge65: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 55, fivePercent: 50, ageRated: 50 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		},
		toAge70: 
		{
			minAges: { level: 18, fivePercent: 20, ageRated: 20 },
			maxAges: { level: 65, fivePercent: 60, ageRated: 60 },
			minCovers: { defaults: { any: 2000 } },
			maxCovers: {
				defaults: { level: 75000, fivePercent: 100000, ageRated: 100000 },
				professional: { any: 112500 }
			}
		}
	}
};

export const getValidationCriteria = obj => {
	const {
		benefitValidationObj,
		targets,
		selectedTargets,
		occupation,
		qualification,
		age,
		toAge
	} = obj;

	let companyCriteria = {};

	const premiumPattern = premiumPatternMap[obj.premiumPattern];
	const anualSalary = parseFloat(obj.anualSalary);

	selectedTargets.map(targetId => {
		const target = targets.find(t => t.id === targetId);
		if (!target) {
			return targetId;
		}
		const targetName = target.name;

		let validationObj = benefitValidationObj[`target${targetId}`];

		if (!validationObj) return targetId;

		if (validationObj[`toAge${toAge}`]) {
			validationObj = validationObj[`toAge${toAge}`];
		} else if (validationObj.toAgeAny) {
			validationObj = validationObj.toAgeAny;
		}

		companyCriteria[targetName] = {};

		const minAge =
			validationObj.minAges[premiumPattern] ||
			validationObj.minAges.any ||
			null;

		let maxAge =
			validationObj.maxAges[premiumPattern] ||
			validationObj.maxAges.any ||
			null;

		if (
			maxAge.toString().includes('yearsBeforeBenefitCeaseAge:') &&
			!isNaN(toAge)
		) {
			maxAge = parseInt(toAge, 10) - parseInt(maxAge.split(':')[1], 10);
		}

		companyCriteria[targetName].minAge = minAge;
		companyCriteria[targetName].maxAge = maxAge;

		let minCover =
			validationObj.minCovers.defaults[premiumPattern] ||
			validationObj.minCovers.defaults.any ||
			null;

		if (minCover === '20xAnSal') minCover = anualSalary * 20;

		let maxCover = validationObj.maxCovers.absoluteMax
			? validationObj.maxCovers.absoluteMax.any
			: validationObj.maxCovers.defaults[premiumPattern] ||
			  validationObj.maxCovers.defaults.any ||
			  null;

		if (
			occupation.toLowerCase().includes('student') &&
			validationObj.maxCovers.students
		) {
			if (validationObj.maxCovers.students.any) {
				maxCover = validationObj.maxCovers.students.any;
			} else {
				Object.keys(validationObj.maxCovers.students).map(ageKey => {
					if (ageKey.includes('-')) {
						const minStudentAge = parseInt(ageKey.split('-')[0], 10);
						const maxStudentAge = parseInt(ageKey.split('-')[1], 10);

						if (age >= minStudentAge && age <= maxStudentAge) {
							maxCover = validationObj.maxCovers.students[ageKey];
						}
					} else if (ageKey.includes('+')) {
						const minStudentAge = parseInt(ageKey.split('+')[0], 10);

						if (age >= minStudentAge) {
							maxCover = validationObj.maxCovers.students[ageKey];
						}
					}

					return ageKey;
				});
			}
		}

		if (
			(qualification === '3-yearDegreeOr4-yearDiploma' ||
				qualification === '4-yearDegreeOrProfessional') &&
			validationObj.maxCovers.professional
		) {
			maxCover = validationObj.maxCovers.professional.any;
		}

		if (maxCover === '20xAnSal') maxCover = anualSalary * 20;

		companyCriteria[targetName].minCover = minCover;
		companyCriteria[targetName].maxCover = maxCover;

		return targetId;
	});

	return companyCriteria;
};

export const validateCriteria = (
	criteria,
	obj,
	minAmount = 1,
	maxAmount = null
) => {
	let companyErrors = {};
	const age = parseInt(obj.age, 10);
	const amount = parseFloat(obj.amount);

	Object.keys(criteria).map(company => {
		let messages = [];

		let { minAge, maxAge, minCover, maxCover } = criteria[company];

		if (
			(minAge && minAge !== 'na' && age < minAge) ||
			(maxAge && maxAge !== 'na' && age > maxAge)
		) {
			messages.push(
				`Client's age must be between ${minAge} and ${maxAge} to qualify`
			);
		}

		if (amount >= minAmount && (maxAmount ? amount <= maxAmount : true)) {
			if (minCover && minCover !== 'na' && amount < minCover) {
				messages.push(`Cover Amount must be ${minCover} or greater.`);
			}

			if (maxCover && maxCover !== 'na' && amount > maxCover) {
				messages.push(`Cover Amount must be  ${maxCover} or less`);
			}
		}

		if (messages.length > 0) companyErrors[company] = { messages: messages };

		return company;
	});
	return companyErrors;
};

export const premiumPatternMap = {
	Level: 'level',
	Compulsory: 'fivePercent',
	AgeRated: 'ageRated'
};



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/BenifitCompanyValidation.js